const FIELD_LABELS: Readonly<Record<string, string>> = {
  pricing_type: 'Pricing type',
  signed_price: 'Signed price',
  lme_price: 'LME price',
  premium_discount: 'Premium / discount',
  payable_percent: 'Payable %',
  ticket: 'Ticket',
};

export function pricingFieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? field;
}

export function pricingFieldLabels(fields: readonly string[]): string {
  return fields.map(pricingFieldLabel).join(', ');
}

// The footer-line explanation for a save disabled by pricing readiness — the
// dialog body carries the detailed alert; this echoes the cause next to the
// disabled button. Empty when pricing is ready.
export function pricingReadinessBlockers(args: {
  readonly pricingReady: boolean;
  readonly missingFields: readonly string[];
  readonly readinessLoaded: boolean;
}): string[] {
  if (args.pricingReady) return [];
  if (!args.readinessLoaded) return ['Checking pricing readiness…'];
  if (args.missingFields.length === 0) {
    return ['Pricing inputs are not ready on the parent ticket.'];
  }
  return [`Missing on the parent ticket: ${pricingFieldLabels(args.missingFields)}.`];
}
